import { render, staticRenderFns } from "./sliderpc.vue?vue&type=template&id=b012742a&scoped=true"
import script from "./sliderpc.vue?vue&type=script&lang=js"
export * from "./sliderpc.vue?vue&type=script&lang=js"
import style0 from "./sliderpc.vue?vue&type=style&index=0&id=b012742a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ttdsr6iin4x3g2fvcnaxmmvtfm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b012742a",
  null
  
)

export default component.exports